// any app specific constants that you don't want to keep in config can go here.
export const messages = {
  dashboard: {
    NOT_FOUND_404: '404: page not found!',
  },
  themes: ['RedTheme', 'BlueTheme'],
};
